
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Custom extends Vue {
  @Prop({ required: true })
  public data!: any
}
